import Vue from 'vue'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import axios from 'axios'
import {bus} from '../../components/User/bus-user'
import _ from "lodash";

export var user_service = new Vue({
    data() {
        return {
            constants: {},
            full_url: ''
        }
    },
    methods: {
        async GetAllRestaurant() {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/restaurant_index',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {

                    bus.GetAllRestaurant(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllDealer() {
            await axios({
                method: 'GET',
                url: this.full_url + 'users/filter/2',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {
                    bus.GetAllDealer(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllDiscounts() {
            await axios.get(this.full_url + 'discounts')
                .then(function (response) {
                    bus.GetAllDiscounts(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllUsersVal() {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/user_index/',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {
                    bus.GetAllUserVal(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllUsers(isactive) {
            await axios({
                method: 'POST',
                url: this.full_url + 'users/filter/1',
                data: {
                    isactive:isactive
                }
            })
                .then(function (response) {
                    bus.GetAllUser(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllUsersSearch(data) {
            await axios.get(this.full_url + 'search/user_index/' + data)
                .then(function (response) {
                    bus.GetAllUser(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetUsersByType(id) {
            await axios({
                method: 'GET',
                url: this.full_url + 'users/getuserBytype/' + id
            })
                .then(function (response) {
                    bus.GetUsersByType(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllUserPagination(page,isactive) {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/user_index/',
                data: {
                    from: page,
                    size: 10,
                    isactive:isactive
                }
            })
                .then(function (response) {
                    bus.GetAllUserPagination(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetUserType() {
            await axios.get(this.full_url + 'usertype/filter/1')
                .then(function (response) {
                    bus.GetAllTypeUser(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GettypeClient() {

            await axios.get(this.full_url + 'typeclient')
                .then(function (response) {

                    bus.GetAllTypeClient(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async CreateUser(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'users',
                data: data
            })
                .then(function (response) {
                    bus.ResponseCreateUser(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async UpdateUser(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'users',
                data: data
            })
                .then(function (response) {
                    bus.ResponseUpdateUser(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        GetValidateEmail(data) {
            axios({
                method: 'GET',
                url: this.full_url + 'users/validemail',
                data: data
            })
                .then(function (response) {
                    bus.GetValdateMail(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetValidateUser(data) {
            await axios.get(this.full_url + 'users/valideuser/' + data)
                .then(function (response) {
                    bus.GetValdateUser(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async DeleteUser(data){
            await axios({
                method: 'POST',
                url: this.full_url + 'users/deleteat',
                data: data
            })
                .then(function (response) {
                    bus.DeleteUser(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        }
    },
    created() {
        (TEST_ENVIRONMENT) ? this.constants = CONSTANTS_TEST : this.constants = CONSTANTS_PROD;
        this.full_url = this.constants.URL_API + this.constants.VERSION_API;
    }
});
